import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { bridgeBackgroundOptions } from "../../src/bridge_background_options"

export default class extends BridgeComponent {
    static component = "notification"

    connect() {
        super.connect()

        // Enable the notification button in the native app
        this.send("connect", bridgeBackgroundOptions(this.element), (message) => {
            if (message.data.notifications !== undefined) {
                this.handleNotificationsRequest()
            }
        })
    }

    handleNotificationsRequest() {
        window.Turbo.visit('/notifications')
    }
}
